/**
 * "Show this on disk" — the desktop shell's reveal bridge, worded for the
 * host OS. Browser builds have no filesystem, so call sites gate on
 * isDesktop() before offering it.
 */

import { getDesktop } from './desktop';

/** What this OS calls its file manager. */
export function revealLabel(): string {
  const platform =
    getDesktop()?.platform ?? (typeof navigator !== 'undefined' ? navigator.platform : '');
  if (platform === 'darwin' || /mac/i.test(platform)) return 'Reveal in Finder';
  if (platform === 'win32' || /win/i.test(platform)) return 'Show in File Explorer';
  return 'Show in File Manager';
}

/** Reveal a stored record. Resolves false when the shell could not open it. */
export async function revealRecord(namespace: string, key: string): Promise<boolean> {
  const desktop = getDesktop();
  if (!desktop?.reveal) return false;
  try {
    const result = await desktop.reveal(namespace, key);
    return result?.ok === true;
  } catch {
    return false;
  }
}
